import * as Sentry from "@sentry/nextjs";

/** The session page open in this browser; a second view replaces the first. Tag names match the backend and codesmith Sentry projects. */
export interface SessionTelemetryScope {
  sessionId: string;
  installationModelId: number | string | null | undefined;
  source: string | null | undefined;
}

const TAG_KEYS = ["session_id", "installation_model_id", "session_source"];

let active: SessionTelemetryScope | null = null;

export function enterSessionTelemetryScope(scope: SessionTelemetryScope): void {
  active = scope;
  const sentryScope = Sentry.getIsolationScope();
  sentryScope.setTag("session_id", scope.sessionId);
  sentryScope.setTag(
    "installation_model_id",
    scope.installationModelId == null
      ? undefined
      : String(scope.installationModelId),
  );
  sentryScope.setTag("session_source", scope.source ?? undefined);
}

/** A newer scope for another session is left in place. */
export function leaveSessionTelemetryScope(sessionId: string): void {
  if (active?.sessionId !== sessionId) return;
  active = null;
  const sentryScope = Sentry.getIsolationScope();
  for (const key of TAG_KEYS) sentryScope.setTag(key, undefined);
}

export function activeSessionTelemetryScope(): SessionTelemetryScope | null {
  return active;
}
